module.exports = new __parcel__URL__("80221_sq.20cbca97.jpg").toString();